module.exports = __webpack_public_path__ + "static/media/lot-img.cdeb2710.png";